export default __webpack_public_path__ + "static/media/account-table-view.42ea453d.svg";